import { get } from 'lodash';

import Constants, { AuthnPolicyConsts } from 'client/util/Constants';
import Util from 'client/util/Util';
import policyOptions from 'client/Security/data/GlobalFallbackPolicyActions';

const simplePolicy = (policy) => ({
  action: get(policy, 'effect.action'),
  isMFARequired: get(policy, 'effect.obligations.mfa.required', false),
});

const getPolicyOptionsByStateName = (statename) => get(policyOptions, statename, []);

const getLdapUrl = () => {
  const { local, staging, production } = Constants.environments;
  const urls = {
    [local]: AuthnPolicyConsts.ldapMfaUrls.local,
    [staging]: AuthnPolicyConsts.ldapMfaUrls.staging,
    [production]: AuthnPolicyConsts.ldapMfaUrls.production,
  };

  return urls[Util.getEnvironment()] || urls.production;
};

export {
  getLdapUrl,
  getPolicyOptionsByStateName,
  simplePolicy,
};
